import React, { ReactNode } from "react";
import emojiRegex from "emoji-regex";
import replace from "string-replace-to-array";
import { Emoji, getEmojiFromNative } from "../Emoji";
import styles from "./TextWithEmoji.module.css";
import emojiMap from "./emojimap.json";
import classNames from "classnames";

const regex = emojiRegex();

const replaceUnicodeEmoji = (match: string) => {
  const emoji = getEmojiFromNative(match);
  if (!emoji) return match;
  return <Emoji size={16} emoji={emoji.colons ?? emoji} />;
};

const smileToEmoji = (text: string) => {
  return text
    .split(" ")
    .map((word) => {
      if (word in emojiMap) return (emojiMap as any)[word];
      else return word;
    })
    .join(" ");
};

export const TextWithEmoji = React.memo<
  { text: string } & JSX.IntrinsicElements["span"]
>(({ text, className, ...rest }) => {
  return (
    <>
      {replace<string | ReactNode>(
        smileToEmoji(text),
        regex,
        replaceUnicodeEmoji
      ).map((item, index) => {
        return (
          <span
            className={classNames(
              className,
              typeof item !== "string" ? styles.emoji : undefined
            )}
            key={index}
            {...rest}
          >
            {item}
          </span>
        );
      })}
    </>
  );
});
